import script from "./CartSubtotal.vue?vue&type=script&setup=true&lang=js"
export * from "./CartSubtotal.vue?vue&type=script&setup=true&lang=js"

import "./CartSubtotal.vue?vue&type=style&index=0&id=439243b0&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-439243b0"]])

export default __exports__